import React from 'react';
import Layout from '@/components/layout/Layout';
import { CalendarClock } from 'lucide-react';
import TeacherAvailabilityTab from '../Teachers/TeacherAvailabilityTab';
import { useAuth } from '@/context/AuthContext';

/**
 * Lehrer-Self-Service: pflege der eigenen Verfügbarkeit und Abwesenheiten.
 * Sichtbar für User mit Rolle 'teacher' oder 'lehrer' und einem verlinkten
 * ``teacher_id``. Verwendet ``selfMode`` damit die Komponente die Endpoints
 * ``/teacher/...`` statt ``/admin/teachers/{id}/...`` ansteuert.
 */
export default function TeacherAvailabilitySelfPage() {
  const { user } = useAuth();

  const roleNames = (user?.roles || []).map((r) => r.name);
  const isTeacher = roleNames.includes('teacher') || roleNames.includes('lehrer');

  if (!isTeacher) {
    return (
      <Layout>
        <div className="max-w-4xl mx-auto py-8 px-4">
          <div className="bg-rose-50 border border-rose-200 rounded-xl p-6 text-rose-800" data-testid="teacher-availability-not-authorized">
            Dieser Bereich ist Lehrkräften vorbehalten.
          </div>
        </div>
      </Layout>
    );
  }

  if (!user?.teacher_id) {
    return (
      <Layout>
        <div className="max-w-4xl mx-auto py-8 px-4">
          <div className="bg-amber-50 border border-amber-200 rounded-xl p-6 text-amber-900" data-testid="teacher-availability-missing-bridge">
            Ihr Benutzerkonto ist noch mit keiner Lehrkraft verknüpft.
            Bitte wenden Sie sich an die Verwaltung, damit Ihre Verfügbarkeit
            hier gepflegt werden kann.
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="max-w-5xl mx-auto py-6 px-4" data-testid="teacher-availability-self-page">
        <div className="flex items-center gap-3 mb-6">
          <div className="h-10 w-10 rounded-lg bg-brand-red/5 text-brand-red flex items-center justify-center">
            <CalendarClock className="h-5 w-5" />
          </div>
          <div>
            <h1 className="text-2xl font-semibold text-slate-900">Meine Verfügbarkeit</h1>
            <p className="text-sm text-slate-500">
              Pflegen Sie Ihre wöchentlichen Zeitfenster und Abwesenheiten. Die Verwaltung nutzt diese Termine
              bei der Online-Anmeldung.
            </p>
          </div>
        </div>
        <TeacherAvailabilityTab teacherId={user.teacher_id} selfMode={true} />
      </div>
    </Layout>
  );
}
